<h4><b>We would appreciate your feedback! How satisfied are you with this application?</b></h4>
<div class="label">*This form is for general feedback only.</div>
<form (ngSubmit)="form.valid && submitFeedback()" autocomplete="off" #form="ngForm">
  <div class="form-group form-row">
    <div>
      @for (item of ratings; track item; let i = $index) {
        <button
          class="btn rating"
          type="button"
          [class.selected]="feedback.rating === item.rating"
          (click)="selectRating(item.rating)"
          [attr.aria-label]="item.rating + ' star'"
        >
          <i [class]="item.iconClass"></i>
        </button>
      }
    </div>
  </div>

  @if (feedback.rating <= 5) {
    <div class="form-group form-row">
      <label for="notes" class="col-0 col-form-label"
        >Enter your comment below. Do not include PHI. For assistance with technical issues, or for questions/requests
        that require follow-up, please submit a support ticket via the Support page.</label
      >
      <div class="col-12">
        <textarea
          type="text"
          name="notes"
          rows="5"
          id="notes"
          [(ngModel)]="feedback.notes"
          class="form-control"
          [maxlength]="notesMaxLength"
          #notes="ngModel"
        ></textarea>
        <div>{{ feedback.notes | characterCount: notesMaxLength }}</div>
      </div>
    </div>
  }

  <div class="modal-footer">
    <button class="btn btn-primary" [disabled]="!feedback.rating || submitting" type="submit">Submit Feedback</button>
    <button type="button" [disabled]="submitting" class="btn btn-outline-primary" (click)="modalService.dismissAll()">
      Cancel
    </button>
  </div>
</form>
